var Avisos = (function () {
    function Avisos(cantidad, descr, codigo) {
        this.cantidad = cantidad;
        this.descr = descr;
        this.codigo = codigo;
    }
    return Avisos;
}());
export { Avisos };
var Notificacion = (function () {
    function Notificacion(total, avisos) {
        this.total = total;
        this.avisos = avisos;
    }
    return Notificacion;
}());
export { Notificacion };
//# sourceMappingURL=notificacion.js.map